/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getAllIntegrationConfigurationsOverrides';

export type GetAllIntegrationConfigurationsPathParams = NonNullable<
  operations['getAllIntegrationConfigurations']['parameters']['path']
>;

export type GetAllIntegrationConfigurationsQueryParams = NonNullable<
  operations['getAllIntegrationConfigurations']['parameters']['query']
>;

export interface Input extends GetAllIntegrationConfigurationsPathParams {
  apiVersion?: string;
  query?: GetAllIntegrationConfigurationsQueryParams;
}

export async function getAllIntegrationConfigurations(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/integration-configurations/keys/{integrationKey}', {
    params: { path, query },
    headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
    signal,
  });
}
